import axiosInstance from "../../lib/axiosInstance"
import {
  CLEAR_AUTH,
  LOGIN_FAILURE,
  LOGOUT_USER,
  SET_TOKEN,
  SET_USER,
} from "./actionTypes"
import { handleApiError } from "../../utils/errorUtils"

export const setToken = (token) => ({
  type: SET_TOKEN,
  payload: token,
  isAuthenticated: true,
})

export const setUser = (user) => ({
  type: SET_USER,
  payload: user,
  isAuthenticated: true,
})

export const loginFailure = (error) => ({
  type: LOGIN_FAILURE,
  payload: error,
  isAuthenticated: false,
})

export const clearAuth = () => ({
  type: CLEAR_AUTH,
})

export const logoutUser = () => ({
  type: LOGOUT_USER,
})

export const userLogAuditing = async (updatedData, toastRef) => {
  try {
    await axiosInstance.patch("/api/loginAuditing", updatedData)
  } catch (error) {
    handleApiError(error, toastRef)
    console.error("Error updating user:", error)
  }
}
